module.exports = __webpack_public_path__ + "static/img/85.eefafe49.jpg";